/// Si le visiteur a accepté les cookies de Google Analytics
document.addEventListener('DOMContentLoaded', function () {
	if (helpers.getCookie('axeptio_cookies') != undefined && helpers.getCookie('axeptio_cookies') != '') {
		window.load = JSON.parse(helpers.getCookie('axeptio_cookies')).google_analytics && setTaggage();
	}
})

$(document).ajaxComplete(function (event, xhr, settings) {
	if (!String.prototype.startsWith) {
		String.prototype.startsWith = function (str, word) {
			return str.lastIndexOf(word, 0) === 0;
		}
	}
	if (settings.url == '/ListeResultats/FiltreListeResultats' || settings.url == '/ListeResultats/TrierListeResultats' || settings.url == '/ListeResultats/CalculFiltreListeResultats' || settings.url == '/ListeResultats/ListeVoyages') {

		/// Si le visiteur a accepté les cookies de Google Analytics
		if (require("common/helpers").getCookie('axeptio_cookies') != undefined && require("common/helpers").getCookie('axeptio_cookies') != '') {
			window.load = JSON.parse(require("common/helpers").getCookie('axeptio_cookies')).google_analytics && setTaggage();
		}
	}
});